//import { TweenMax, TweenLite, TimelineMax, Quart, Expo } from 'gsap';
//import ScrollMagic from 'scrollmagic';

var Home = {};

//--------------
// Variables
//--------------
var controller = new ScrollMagic.Controller({
  refreshInterval: 0
});

Home.width = null;
Home.tlScrollableElement = new TimelineMax();
Home.serviceItem = new TimelineMax();

//--------------
// Functions
//--------------

/**
 * Init animations on scroll
 * @return {void}
 */
Home.initScrollable = function(){
	var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

	var y = 0;
	var colImageHeight = $('.js-home-banner-col-image').height();
	var colImageHeight10 = colImageHeight + (colImageHeight*10)/100 + 10;

	//-- Set banner image height
	$('.js-home-banner-image').css({height: colImageHeight10});

	// update scrollY controller
	if(isChrome){
		controller.scrollPos(function () {
			return y;
		});
	}

	//-- Banner image animation on scroll
	// Home.tlScrollableElement = new TimelineMax();
	Home.tlScrollableElement.to('.js-home-banner-image', 1, { yPercent: 5 });
	Home.tlScrollableElement.fromTo('.js-home-banner-col-image', 1, { height: '100%' }, { height: '95%' }, 0);
	Home.tlScrollableElement.fromTo('.js-home-banner-text-wrapper', 1, { yPercent: 0 }, {yPercent: '50' }, 0);


	Home.scene = new ScrollMagic.Scene({
	    triggerElement: '',
	    duration: $(window).height() * 2,	// the scene should last for a scroll distance of 100px
	    triggerHook: 0,		// start this scene after scrolling for 50px
	})
	.setTween(Home.tlScrollableElement) // the tween durtion can be omitted and defaults to 1
	//.addIndicators({name: "home banner"})
	.addTo(controller);

	if(!isChrome){
		Home.scene.triggerElement('.js-home-banner');
	}

	Home.serviceItem = new TimelineMax();
	Home.serviceItem.fromTo(".js-service-col-2", 1, { y: 0 }, { y: -200 }, 0.075);
	Home.serviceItem.fromTo(".js-service-col-3", 1.5, { y: 0 }, { y: -200 }, 0.075);

	Home.scene2 = new ScrollMagic.Scene({
	    triggerElement: '.js-services-items',
	    duration: $(window).height() * 5
	})
	.setTween(Home.serviceItem)
	.addTo(controller);

	// add listener to refresh the scene manually
	Scrollbar.addListener(function(status) {
		y = status.offset.y;

		if(isChrome){ 
		  controller.update();
		} else {
		  Home.scene.refresh();       
		  Home.scene2.refresh();     
		}
	});

	Scrollbar.removeListener();
}

/**
 * initFadein
 * @return {}
 */
Home.initFadein = function(){
	Home.tlFadeIn = new TimelineMax();

	// Banner image
	Home.tlFadeIn.staggerFromTo('.js-home-banner-col-image', 1.2, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.02, 0);
	Home.tlFadeIn.staggerFromTo('.js-home-banner-col-image', 1.8, {yPercent: 40}, {yPercent: 0, force3D:true, ease: Quart.easeOut}, 0.02, 0);

    //-- Banner text
	Home.tlFadeIn.staggerFromTo('.js-home-banner-text', 1, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.15, 0.6);
	Home.tlFadeIn.staggerFromTo('.js-home-banner-text', 1.5, {xPercent: 60}, {xPercent: 0, force3D:true, ease: Quart.easeOut}, 0.15, 0.6);
}


/**
 * Init Events
 * @return {[type]} [description]
 */
Home.initEvents = function(){
	if(Home.width >= 992 && $(window).width() < 992){
		Home.destroyForTablet();
	}

	if(Home.width < 992 && $(window).width() >= 992){
		Home.initForDesktop();
	}
}

/**
 * Init for Desktop
 * @return {[type]} [description]
 */
Home.initForDesktop = function(){
	Home.initScrollable();
}

/**
 * Destroy animations for Tablet (and Mobile)
 * @return {[type]} [description]
 */
Home.destroyForTablet = function(){
	TweenMax.killTweensOf(".js-service-col-2");﻿
	TweenMax.set(".js-service-col-2", { clearProps: 'all' });

	TweenMax.killTweensOf(".js-service-col-3");﻿
	TweenMax.set(".js-service-col-3", { clearProps: 'all' });
}

/**
 * Init home scripts
 * @return {[type]} [description]
 */
Home.init = function() {
	Home.initFadein();
	//Home.initEvents();
	Home.width = $(window).width();

	if($(window).width() >= 992){
		Home.initForDesktop();
	}

	//-- On resize
	$(window).on('resize', function() {
		Home.initEvents();
		Home.width = $(window).width();
	});
}

/**
 * Destroy home scripts
 * @return {void}
 */
Home.destroy = function() {

}

//--------------
// Execution
//--------------

module.exports = Home;